import { PublicEventType } from '../enums';
import { publicAddToCartResponsePayloadValidator } from '../events';
import {
  PublicEventPayloadByType,
  PublicEventPayloadValidator,
} from '../types';

const publicEventPayloadValidators: Partial<{
  [EventType in PublicEventType]: PublicEventPayloadValidator<EventType>;
}> = {
  [PublicEventType.AddToCartResponse]: publicAddToCartResponsePayloadValidator,
};

export const isPublicEventPayload = <EventType extends PublicEventType>(
  type: PublicEventType,
  payload: unknown
): payload is PublicEventPayloadByType[EventType] => {
  const validator = publicEventPayloadValidators[type];
  if (!validator) return false;
  return validator(payload);
};
